<template>
  <div
    class="article-card article-card--skeleton"
    :class="articleClass"
  >
    <USkeleton class="article-card__aside"/>
    <div class="article-card__body mt-2">
      <USkeleton class="article-card__title" />
      <USkeleton class="article-card__title" />
      <USkeleton class="article-card__title" />
    </div>
  </div>
</template>

<script setup lang="ts">
import type {PropType} from "vue";

const props = defineProps({
  article: {type: Object as PropType<ArticleLocal>, required: false},
  type: { type: String as PropType<ArticleComponentType>, required: false, default: ArticleComponentType.DEFAULT },
})
import ArticleComponentType from "~/libs/constants/ArticleComponentType";
import type ArticleLocal from "~/libs/interfaces/ArticleLocal";

const articleClass = computed(() => {
  switch (props.type) {
    case ArticleComponentType.BIG:
      return 'article-card--big'
    case ArticleComponentType.MAIN:
      return 'article-card--big article-card--overlay'
    case ArticleComponentType.SEARCH:
      return 'article-card--search'
    case ArticleComponentType.SIDE:
      return 'article-card--side'
    case ArticleComponentType.RECOMMENDED:
      return 'article-card--recommended'
    case ArticleComponentType.DEFAULT:
    default:
      return ''
  }
})
</script>

<style scoped lang="postcss">

</style>